/**
 *
 */

import { default as SearchToggle } from './searchToggle'
class MobileNavActivator {
    constructor() {
        window.addEventListener('resize', this.setWindowHeightProp)
    }

    open() {
        /*
        if ($('.searchWrap').is(":visible")) {
            $('.search-act, .searchWrap').removeClass('open');
            $('.search-act, .searchWrap').addClass('close');
        }
        */
        SearchToggle.close()
        this.navActivator.classList.add('open')
        this.header.classList.add('openNav')
        document.documentElement.classList.add('menuOpen')



        //$('.navWrap').removeClass('off-canvas');
    }

    setWindowHeightProp() {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        var vh = window.innerHeight * 0.01
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`)
    }

    close() {
        this.navActivator.classList.remove('open')
        this.header.classList.remove('openNav')
        document.documentElement.classList.remove('menuOpen')
    }

    init() {
        this.navActivator = document.querySelector('.nav-activator')
        this.header = document.querySelector('.headerNav')
        if (this.navActivator) {
            this.navActivator.addEventListener('click', (event) => {
                /*
				var headerHeight = header.getBoundingClientRect().height
				var navHeight = window.innerHeight
				var windowHeight = navHeight - headerHeight
				*/
                if (this.navActivator.classList.contains('open')) {
                    this.close()
                } else {
                    this.open()
                }
            })
        }
    }
}

export default new MobileNavActivator() // singleton instance
